module.exports = __webpack_public_path__ + "img/scaleNotice.d05fd9fb.png";